export default "__VITE_ASSET__DI2BRZ9O__"